export interface IconProps {
  size?: string;
  backgroundColor?: string;
  color?: string;
  width?: string;
  height?: string;
}

const Close = ({ size, backgroundColor, color }: IconProps) => {
  return (
    <svg
      id="Close_icon"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size || '18'}
      height={size || '18'}
      viewBox="0 0 48 48"
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="사각형_2118"
            data-name="사각형 2118"
            width="46"
            height="46"
            transform="translate(260 496)"
            fill={backgroundColor || '#fff'}
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <rect id="사각형_2119" data-name="사각형 2119" width="48" height="48" fill="none" />
      <g
        id="마스크_그룹_183"
        data-name="마스크 그룹 183"
        transform="translate(-259 -495)"
        clipPath="url(#clip-path)"
      >
        <g id="Layer_2" data-name="Layer 2" transform="translate(260.991 496.993)">
          <g id="Layer_2-2" data-name="Layer 2">
            <rect
              id="사각형_2116"
              data-name="사각형 2116"
              width="60.269"
              height="4.779"
              rx="2.39"
              transform="translate(45.009 2.388) rotate(135)"
              fill={color || '#404040'}
            />
            <rect
              id="사각형_2117"
              data-name="사각형 2117"
              width="60.269"
              height="4.779"
              rx="2.39"
              transform="translate(2.388 -0.991) rotate(45)"
              fill={color || '#404040'}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Close;
